module.exports = __webpack_public_path__ + "img/main_img_3.c7b9cace.png";